import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  getConfigurableEmails,
  saveConfigurableEmailsForUser as requestSaveConfigurableEmailsForUser,
} from 'api/operations/emailService';
import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { ConfigurableEmailInfo } from 'types/emailService';

export default class NotificationSettingsPageStore {
  private _isInitialDataLoading = false;
  private _isActionLoading = false;

  public emails: ConfigurableEmailInfo[] = [];
  /**
   * List of emails user has selected to receive notifications for
   */
  public emailsForUser: string[] = [];

  public get isInitialDataLoading(): boolean {
    return this._isInitialDataLoading;
  }

  public get isActionLoading(): boolean {
    return this._isActionLoading;
  }

  public get canComplete(): boolean {
    return !(this._isInitialDataLoading || this._isActionLoading);
  }

  public async getInitialData(): Promise<void> {
    this._isInitialDataLoading = true;
    const res = await getConfigurableEmails();
    runInAction(() => {
      this.emails = res.emails;
      this.emailsForUser = res.emailsForUser;
      this._isInitialDataLoading = false;
    });
  }

  public async saveSelectedEmails(): Promise<void> {
    this._isActionLoading = true;
    const res = await requestSaveConfigurableEmailsForUser([...this.emailsForUser]);

    await runInAction(async () => {
      if (res) {
        toastManager.addToast('Email list updated successfully', ToastColorTypes.SUCCESS);
      } else {
        toastManager.addToast(
          'Something went wrong while updating the email list. Please try again or contact support.',
          ToastColorTypes.WARNING,
        );
        await this.getInitialData();
      }
      this._isActionLoading = false;
    });
  }

  public updateEmailCheckStatus(emailType: string): void {
    if (this.emailsForUser.includes(emailType)) {
      this.emailsForUser = this.emailsForUser.filter((type) => type !== emailType);
    } else {
      this.emailsForUser = [...this.emailsForUser, emailType];
    }
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const NotificationSettingsPageStoreContext = createContext(new NotificationSettingsPageStore());

export const useNotificationSettingsPageStore = (): NotificationSettingsPageStore => {
  return useContext(NotificationSettingsPageStoreContext);
};

export { NotificationSettingsPageStore, NotificationSettingsPageStoreContext };
